/** @jsxImportSource @emotion/react */
import {
  Loading,
  EmptyContent,
  Header,
} from '@quickbit/backoffice-core-frontend';
import { Snackbar, Button, Typography } from '@quickbit/qb-design-system';
import { useState } from 'react';
import { Route, Routes } from 'react-router-dom';
import { usePlatformApi } from 'api/usePlatformApi';
import { PlatformList, PlatformDetails } from './components';

type Alert = {
  type: 'success' | 'danger';
  show: boolean;
  message: string;
};

export const Platforms = () => {
  const [alert, setAlert] = useState<Alert>({
    type: 'success',
    show: false,
    message: '',
  });
  const { getPlatformList } = usePlatformApi();
  const {
    data: platforms,
    isPending,
    error,
    refetch: getPlatforms,
  } = getPlatformList();

  return (
    <>
      <Loading loading={isPending} />

      {error && (
        <>
          <Header>
            <Typography variant="subtitle">Platforms</Typography>
          </Header>
          <EmptyContent
            heading="Oops! It's empty."
            body="Something went wrong"
            action={
              <Button
                text="Try again"
                variant="primary"
                onClick={() => getPlatforms()}
              />
            }
          />
        </>
      )}

      {platforms && (
        <Routes>
          <Route path="/" element={<PlatformList platforms={platforms} />} />
          <Route
            path="/:platformId"
            element={
              <PlatformDetails
                platforms={platforms}
                onSuccess={(message: string) => {
                  setAlert({ show: true, type: 'success', message });
                  void getPlatforms();
                }}
                onError={(message: string) =>
                  setAlert({ show: true, type: 'danger', message })
                }
              />
            }
          />
        </Routes>
      )}
      <Snackbar
        variant={alert.type}
        message={alert.message}
        onClose={() => setAlert({ ...alert, show: false })}
        open={alert.show}
        hideDuration={null}
      />
    </>
  );
};
